import { render } from "./Tarik.vue?vue&type=template&id=7c1137ca"
import script from "./Tarik.vue?vue&type=script&lang=js"
export * from "./Tarik.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__